import React            from 'react';
import FieldValidation  from '../Fragments/FieldValidation';
import FieldError       from '../Fragments/FieldError';
import Modal            from '../Fragments/Modal';
import HelpIcon         from '../Fields/HelpIcon';
import HelpText         from '../Fields/HelpText';

let Quote =             require('../Managers/Quote');
let Questions =         require('../Managers/Questions');
let Validation =        require('../Managers/Validation.js');

import ChildQuestion from './ChildQuestion';

const ButtonChoice = React.createClass({
    propTypes: {
        questionId: React.PropTypes.number.isRequired,
        question: React.PropTypes.string.isRequired,
        fieldName: React.PropTypes.string.isRequired,
        options: React.PropTypes.array.isRequired,
        loadCachedValue: React.PropTypes.bool.isRequired,
        helpText: React.PropTypes.string,
        children: React.PropTypes.array,
        supplementaryText: React.PropTypes.string,
        supplementaryTextAfterInput: React.PropTypes.string,
        onSetValue: React.PropTypes.func,
        refName: React.PropTypes.string,
        alternateBackground: React.PropTypes.string,
        noBorder: React.PropTypes.string,
        onChangeTertiary : React.PropTypes.func,
        showValidation: React.PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            showValidation: true,
        };
    },
    getInitialState() {
        let validation = Validation.validate(this.props.fieldName, Quote.getCurrentAnswer(this.props.fieldName))[0];
        let activeValue = null;
        if (Quote.getCurrentAnswer(this.props.fieldName)) {
            activeValue = Quote.getCurrentAnswer(this.props.fieldName);
        }
        let otherOptionValues = Questions.getOtherAnswerOptions(this.props.fieldName).map(function(o) {
            return o.option_value;
        });
        return {
            activeValue,
            childObjects: Questions.getChildren(this.props.children),
            hasError: (validation.hasError) ? true : false,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName) && validation.isValid) ? true : false,
            isHelpVisible: false,
            showChildren: Questions.childrenAreActive(this.props.children, this.props.fieldName),
            childrenToUse: Questions.getChildQuestions(this.props.questionId, Quote.getCurrentAnswer(this.props.fieldName)),
            supplementaryTextModalActive: false,
            supplementaryTextModal: {
                title: null,
                template: null
            },
            otherOptionValues,
            showOtherActiveValues: this.isShowOtherActiveValues(otherOptionValues, activeValue),
            hasOtherOptions: Questions.hasOtherAnswerOptions(this.props.fieldName),
            errors: (validation.errors) ? validation.errors : null,
            showAstModal: false,
        };
    },
    componentWillMount() {
        this.childComponentWrappers = [];
    },
    childComponentWrappers : [],
    doValidation() {
        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },
    getChildComponents() {
        let childComponents = this.childComponentWrappers.filter(c => c != null).map(wrapper => {
            return wrapper.getPrimaryChild();
        });
        return childComponents;
    },
    resetState() {
        this.setState(this.getInitialState());
    },
    isShowOtherActiveValues(otherOptionValues, value) {
        if (otherOptionValues.indexOf(value) >= 0) {
            return true;
        }
        return false;
    },
    setActiveValue(key, value) {
        // Toggle the other button options off and remove their values from the state
        if (this.state.showOtherActiveValues) {
            this.setState({
                showOtherActiveValues: false
            });
        }

        if (typeof this.props.onChangeTertiary == 'function') {
            this.props.onChangeTertiary();
        }

        // if this question has answer dependencies, we set them as well
        let answerDependencyFields = Questions.getAnswerDependencies(this.props.questionId);
        if (answerDependencyFields !== undefined) {
            window.$.each(answerDependencyFields, function(i, e) {
                Quote.set(e, value);
            });
        }

        let validation = Validation.validate(key, value)[0];
        this.setState(validation);
        if (validation.isValid) {
            this.setState({
                isValid: true
            });
        }
        Quote.set(key, value);

        // remove the data for any child questions that are no longer active
        window.$(Questions.getNonActiveChildQuestions(this.props.questionId, value)).each(function(i, e) {
            window.removeLocalStorageAnswer(e.field_name);
        });

        this.setState({
            activeValue: value,
            childrenToUse: Questions.getChildQuestions(this.props.questionId, value)
        });

        if (this.isShowOtherActiveValues(this.state.otherOptionValues, value)) {
            this.setState({
                showOtherActiveValues : true
            });
        }

        if (key == 'payment_frequency') {
            this.setState({
                paymentFrequency: value
            });
        }

        if (this.state.childObjects !== null) {
            this.state.childObjects.map(function(child) {
                if (child.key === value) {
                    this.setState({
                        showChildren: true
                    });
                }
            }, this);
        }

        if (this.props.onSetValue) {
            this.props.onSetValue(value);
        }
    },

    setOtherActiveValue(e) {
        this.setActiveValue(this.props.fieldName, e.target.value);
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },
    showSupplementaryTextModal: function() {
        if (this.props.fieldName === 'property_furnished') {
            this.setState({
                supplementaryTextModalActive: true,
                supplementaryTextModal: {
                    title: 'Compare Limited and Full Contents',
                    template: 'compare-contents-cover'
                }
            });
        }
    },
    closeSupplementaryTextModal: function() {
        this.setState({
            activeValue: Quote.getCurrentAnswer(this.props.fieldName),
            supplementaryTextModalActive: false
        });
    },

    showOtherOptions() {
        this.setState({
            activeValue : null,
            showOtherActiveValues: true
        });
    },

    showAstModal() {
        this.setState({ showAstModal: true });
    },

    closeAstModal(e) {
        e.preventDefault();
        this.setState({
            showAstModal: false
        });
    },

    render() {
        // We want to append a new className to button choices that have only
        // two options available so we don't stretch them out on tablets.
        let numberOfChoices = this.props.options.length;
        let wrapperClass = (numberOfChoices == 2) ? 'button-choices two' : 'button-choices';
        let topClass = (this.props.helpText) ? 'question-top with-help' : 'question-top without-help';
        let self = this;
        let otherOptions = [];
        if (this.state.showOtherActiveValues) {
            Questions.getOtherAnswerOptions(this.props.fieldName).map(function(i, index) {
                otherOptions.push(<option key={index+'_'+Questions.guid()} value={i.option_value}>{i.option_text}</option>);
            }, this);
        }

        let containerClass = '';
        if (this.props.alternateBackground) {
            containerClass = 'alternate-background';
        }

        let questionRowClass = '';
        if (this.props.noBorder) {
            questionRowClass = 'no-border';
        }

        return (
            <div ref={this.props.fieldName+'_'+Questions.guid()} className={containerClass}>
                <question-row class={questionRowClass}>
                    <div className="question-main">

                        <div className={topClass}>
                            <label>{this.props.question}</label>
                            {this.props.helpText ? <HelpIcon onClick={this.toggleHelpText} />: null}
                        </div>

                         {/*this.props.fieldName === "dec_TENANCY" ?
                            <div>
                                <p className="product-cover-supplemental"><a onClick={this.showAstModal} className="underline">What is an Assured Short Hold Tenancy?</a></p>
                                <Modal
                                    title="What is an Assured Shorthold Tenancy?"
                                    isActive={this.state.showAstModal}
                                    closeFunction={this.closeAstModal}
                                    bodyTemplate="ast-help-text"
                                    hasFooter={true}
                                    />
                            </div>
                        : null*/}

                        {this.props.supplementaryText && this.props.fieldName !== 'property_furnished' ?
                            <div onClick={this.showSupplementaryTextModal} className="supplementaryText" dangerouslySetInnerHTML={{__html: this.props.supplementaryText}} />
                        : null}
                        {this.props.supplementaryText && this.props.fieldName === 'property_furnished' ?
                            <div onClick={this.showSupplementaryTextModal} className="supplementaryText underline pointer" dangerouslySetInnerHTML={{__html: this.props.supplementaryText}} />
                        : null}

                        <div className="question-input" id={this.props.fieldName}>
                            <div className={wrapperClass}>
                                {this.props.options.map(function(choice, index) {
                                    let choiceId = (choice.id != undefined) ? choice.id : Math.random();
                                    return (
                                        <div
                                            key={index}
                                            onClick={this.setActiveValue.bind(this, this.props.fieldName, choice.option_value)}
                                            value={choice.value}
                                            id={choiceId}
                                            className={this.state.activeValue == choice.option_value ? 'button-choice active' : 'button-choice'}>
                                            {choice.option_text}
                                        </div>
                                    );
                                }, this)}
                                {this.state.hasOtherOptions ?
                                    <div
                                        onClick={this.showOtherOptions}
                                        className={this.state.showOtherActiveValues ? 'button-choice active' : 'button-choice'}>
                                        Other
                                    </div>
                                : null}
                                {this.state.showOtherActiveValues ?
                                    <select
                                        onChange={this.setOtherActiveValue}
                                        value={this.state.activeValue}
                                        className="otherOptionsSelect">
                                            <option>Please select ...</option>
                                            {otherOptions}
                                        </select>
                                    : null}
                            </div>
                            {this.props.helpText ? <HelpText text={this.props.helpText} active={this.state.isHelpVisible} /> : null}
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                        </div>
                        {this.props.supplementaryTextAfterInput && this.props.fieldName !== 'property_furnished' ?
                            <div className="supplementaryText" dangerouslySetInnerHTML={{__html: this.props.supplementaryTextAfterInput}} />
                        : null}
                        {this.props.fieldName == 'property_furnished' && this.state.activeValue === 'no' ?
                            <div className="supplementaryText" dangerouslySetInnerHTML={{__html: this.props.supplementaryTextAfterInput}} />
                        : null}
                    </div>
                    {this.props.showValidation === true ?
                        <div className="question-extra">
                            <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                        </div>
                    : null}
                </question-row>

                <child-questions>
                {this.state.childrenToUse !== null ?
                    this.state.childrenToUse.map(function(child, index) {
                        return (
                            <ChildQuestion
                                show={this.state.showChildren}
                                key={index+'_'+Questions.guid()}
                                question={child.question}
                                questionId={child.question_id}
                                fieldName={child.field_name}
                                supplementaryId={child.supplementary_id}
                                type={child.type}
                                options={child.options}
                                display_dependencies={child.display_dependencies}
                                parent={child.parent}
                                helpText={child.hint_text}
                                supplementaryText={child.supplementary_html}
                                noBorder={child.is_borderless}
                                ref={function(childWrapper) { self.childComponentWrappers.push(childWrapper); }}
                             />
                        );
                    }, this)

                : null}
                </child-questions>
                {this.state.supplementaryTextModalActive ?
                <Modal
                    closeFunction={this.closeSupplementaryTextModal}
                    title={this.state.supplementaryTextModal.title}
                    bodyTemplate={this.state.supplementaryTextModal.template}
                    isActive={true}
                    setActiveValue={this.setActiveValue}
                    hasFooter={false}
                /> : null }
            </div>
        );
    }
});

export default ButtonChoice;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/ButtonChoice.js
 **/